module.exports = __webpack_public_path__ + "img/plus.a4f9982e.svg";